import React, { useEffect, useState } from 'react';

import { Burger } from './Burger';
import styles from './Header.styles';
import { Logo } from './Logo';
import { Navigation } from './Navigation';

const Header = ({ header, menu }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const bodyStyle = document.body.style;
    if (isMenuOpen) {
      bodyStyle.overflow = 'hidden';
    } else {
      bodyStyle.overflow = null;
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen((isMenuOpen) => !isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  return (
    <header css={styles} className="header">
      <Logo logo={header.headerLogo} logoLink={header.headerLink} />
      <Navigation menu={menu} isMenuOpen={isMenuOpen} closeMenu={closeMenu} />
      <Burger isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
    </header>
  );
};

export default Header;
